const isClipboardApiSupported = (): boolean =>
	Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');

export const useCopyToClipboard = (): {
	copyToClipboard: (value: string | undefined) => Promise<void>;
} => {
	const copyToClipboard = async (value: string | undefined): Promise<void> => {
		if (value && isClipboardApiSupported()) {
			await navigator.clipboard.writeText(value);
		}
	};

	return { copyToClipboard };
};
